module.exports = __webpack_public_path__ + "static/second_user_image2-e2c5ede32a1bf5444db01c7a7d37ce94.jpg";